import React, { Component } from 'react'

import { Typography, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';

import View from 'react-flexbox'

function downloadFile(sUrl) {

    //iOS devices do not support downloading. We have to inform user about this.
    if (/(iP)/g.test(navigator.userAgent)) {
        //alert('Your device does not support files downloading. Please try again in desktop browser.');
        window.open(sUrl, '_blank');
        return false;
    }

    //If in Chrome or Safari - download via virtual link click
    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1 || navigator.userAgent.toLowerCase().indexOf('safari') > -1) {
        //Creating new link node.
        var link = document.createElement('a');
        link.href = sUrl;
        link.setAttribute('target', '_blank');

        if (link.download !== undefined) {
            //Set HTML5 download attribute. This will prevent file from opening if supported.
            var fileName = sUrl.substring(sUrl.lastIndexOf('/') + 1, sUrl.length);
            link.download = fileName;
        }

        //Dispatching click event.
        if (document.createEvent) {
            var e = document.createEvent('MouseEvents');
            e.initEvent('click', true, true);
            link.dispatchEvent(e);
            return true;
        }
    }

    // Force file download (whether supported by server).
    if (sUrl.indexOf('?') === -1) {
        sUrl += '?download';
    }

    window.open(sUrl, '_blank');
    return true;
}
export function dateToString(data) {
    if (!data) {
        return "";
    }
    try {
        data = data.toDate()
    } catch (error) {
        try {
            data = new Date(data.seconds*1000)
        } catch (error) {
    
        }
    }
    try {


        var mm = data.getMonth() + 1; // getMonth() is zero-based
        var dd = data.getDate();
        var minutes = data.getMinutes();
        var hour = data.getHours();
        return [
            (dd > 9 ? '' : '0') + dd,
            (mm > 9 ? '' : '0') + mm,
            data.getFullYear(),
        ].join('/') + " " + hour + ":" + minutes;
    } catch (error) {

        console.log('error', error);
        console.log('data', data);

        return "erro"

    }
}
class ItemAnexo extends Component {
    componentDidMount() {
        this.props.listar()
    }
    render() {

        const { anexo, classes, nomeUsuario } = this.props
        return (
            <Card className={classes.card}>
                <View style={{ paddingLeft: 5, paddingRight:10 }}>

                    <Typography className={classes.cardContent}>
                        {anexo.name}
                    </Typography>
                    <Button variant="contained" color="primary" size="small" onClick={() => { downloadFile(anexo.downloadURL) }}>Ver</Button>
                </View>
                <View style={{ paddingLeft: 5, paddingRight:10 }}>
                    <Typography variant="caption" className={classes.cardData}>{dateToString(anexo.data)}</Typography>
                    <Typography variant="caption" className={classes.cardData}>{nomeUsuario || anexo.userUid}</Typography>
                </View>
            </Card>
        )
    }
}
const styles = {
    card: {
        // maxWidth: 500,
        margin: 3,
    },

    cardContent: {
        paddingLeft: 5,
        paddingTop: 5,
        paddingRight: 5,

    },
    cardData: {
        paddingLeft: 5,


    },

};

export default withStyles(styles)(ItemAnexo);



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Anexos/components/ItemAnexo/ItemAnexo.js